/**
 * @flow
 * @relayHash 7dee335ebec6e3dc5f44c7483f4fab24
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContractsList_jobs$ref = any;
type ContractsList_statusTypes$ref = any;
export type JobsPageQueryVariables = {|
  after?: ?string,
  first?: ?number,
  orderBy?: ?string,
  status?: ?string,
  organization?: ?string,
  orgSequenceId?: ?string,
  staffId?: ?string,
  contractDateFrom?: ?any,
  contractDateTo?: ?any,
  jobDeadlineFrom?: ?any,
  jobDeadlineTo?: ?any,
  name?: ?string,
|};
export type JobsPageQueryResponse = {|
  +__type: ?{|
    +$fragmentRefs: ContractsList_statusTypes$ref
  |},
  +$fragmentRefs: ContractsList_jobs$ref,
|};
export type JobsPageQuery = {|
  variables: JobsPageQueryVariables,
  response: JobsPageQueryResponse,
|};
*/


/*
query JobsPageQuery(
  $after: String
  $first: Int
  $orderBy: String
  $status: String
  $organization: String
  $orgSequenceId: String
  $staffId: String
  $contractDateFrom: Date
  $contractDateTo: Date
  $jobDeadlineFrom: Date
  $jobDeadlineTo: Date
  $name: String
) {
  ...ContractsList_jobs_3u1rKX
  __type(name: "JobStatus") {
    ...ContractsList_statusTypes
  }
}

fragment ContractsList_jobs_3u1rKX on Query {
  allJobs(after: $after, first: $first, orderBy: $orderBy, status: $status, organization: $organization, orgSequenceId: $orgSequenceId, staffId: $staffId, contractDateFrom: $contractDateFrom, contractDateTo: $contractDateTo, jobDeadlineFrom: $jobDeadlineFrom, jobDeadlineTo: $jobDeadlineTo, jobName: $name) {
    totalCount
    edgeCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        jobId
        name
        staffCoordinator {
          fullName
          representativeImageUrl
          organization {
            name
            representativeImageUrl
            currencyCode
            id
          }
          id
        }
        jobDeadline
        totalValue
        contractDate
        status
        currencyCode
        deliverables {
          edges {
            node {
              id
            }
          }
        }
        contract {
          id
          contractFileUrl
          job {
            status
            id
          }
        }
      }
    }
  }
}

fragment ContractsList_statusTypes on __Type {
  enumValues {
    name
    description
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderBy",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "status",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "organization",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orgSequenceId",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "staffId",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "contractDateFrom",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "contractDateTo",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "jobDeadlineFrom",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "jobDeadlineTo",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "name",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "JobStatus"
  }
],
v2 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v3 = {
  "kind": "Variable",
  "name": "contractDateFrom",
  "variableName": "contractDateFrom"
},
v4 = {
  "kind": "Variable",
  "name": "contractDateTo",
  "variableName": "contractDateTo"
},
v5 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v6 = {
  "kind": "Variable",
  "name": "jobDeadlineFrom",
  "variableName": "jobDeadlineFrom"
},
v7 = {
  "kind": "Variable",
  "name": "jobDeadlineTo",
  "variableName": "jobDeadlineTo"
},
v8 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v9 = {
  "kind": "Variable",
  "name": "orgSequenceId",
  "variableName": "orgSequenceId"
},
v10 = {
  "kind": "Variable",
  "name": "organization",
  "variableName": "organization"
},
v11 = {
  "kind": "Variable",
  "name": "staffId",
  "variableName": "staffId"
},
v12 = {
  "kind": "Variable",
  "name": "status",
  "variableName": "status"
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "representativeImageUrl",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currencyCode",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "JobsPageQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "__type",
        "storageKey": "__type(name:\"JobStatus\")",
        "args": (v1/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContractsList_statusTypes",
            "args": null
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "ContractsList_jobs",
        "args": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "JobsPageQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "allJobs",
        "storageKey": null,
        "args": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "Variable",
            "name": "jobName",
            "variableName": "name"
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "concreteType": "JobNodeConnection",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "edgeCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasPreviousPage",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "startCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "JobNodeEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "JobNode",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "jobId",
                    "args": null,
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "staffCoordinator",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StaffNode",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "fullName",
                        "args": null,
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "organization",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OrgNode",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v13/*: any*/)
                        ]
                      },
                      (v13/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "jobDeadline",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalValue",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "contractDate",
                    "args": null,
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  (v16/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "deliverables",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DeliverableNodeConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DeliverableNodeEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DeliverableNode",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "contract",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ContractNode",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "contractFileUrl",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "job",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobNode",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v13/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "__type",
        "storageKey": "__type(name:\"JobStatus\")",
        "args": (v1/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "enumValues",
            "storageKey": null,
            "args": null,
            "concreteType": "__EnumValue",
            "plural": true,
            "selections": [
              (v14/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "JobsPageQuery",
    "id": null,
    "text": "query JobsPageQuery(\n  $after: String\n  $first: Int\n  $orderBy: String\n  $status: String\n  $organization: String\n  $orgSequenceId: String\n  $staffId: String\n  $contractDateFrom: Date\n  $contractDateTo: Date\n  $jobDeadlineFrom: Date\n  $jobDeadlineTo: Date\n  $name: String\n) {\n  ...ContractsList_jobs_3u1rKX\n  __type(name: \"JobStatus\") {\n    ...ContractsList_statusTypes\n  }\n}\n\nfragment ContractsList_jobs_3u1rKX on Query {\n  allJobs(after: $after, first: $first, orderBy: $orderBy, status: $status, organization: $organization, orgSequenceId: $orgSequenceId, staffId: $staffId, contractDateFrom: $contractDateFrom, contractDateTo: $contractDateTo, jobDeadlineFrom: $jobDeadlineFrom, jobDeadlineTo: $jobDeadlineTo, jobName: $name) {\n    totalCount\n    edgeCount\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      node {\n        id\n        jobId\n        name\n        staffCoordinator {\n          fullName\n          representativeImageUrl\n          organization {\n            name\n            representativeImageUrl\n            currencyCode\n            id\n          }\n          id\n        }\n        jobDeadline\n        totalValue\n        contractDate\n        status\n        currencyCode\n        deliverables {\n          edges {\n            node {\n              id\n            }\n          }\n        }\n        contract {\n          id\n          contractFileUrl\n          job {\n            status\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ContractsList_statusTypes on __Type {\n  enumValues {\n    name\n    description\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e11ed82b17c9820f91f3605e3801cdb3';
module.exports = node;
